<template>
  <el-card>
    <h1>发起合同签署请求</h1>
    <el-divider />
    <p class="p-title">
      <strong>接口说明：</strong>
    </p>
    <p>发起企业合同签署请求</p>
    <p class="p-title">
      <strong>请求URL：</strong>
    </p>
    <p>http://api.toursign.cn/contract/template/sign/{contractCode}</p>
    <p class="p-title">
      <strong>请求方式：</strong>
    </p>
    <p>POST</p>
    <p class="p-title">
      <strong>请求参数说明：</strong>
    </p>
    <p>
      <el-table size="mini" border :data="request">
        <el-table-column prop="name" label="参数名称" />
        <el-table-column prop="loc" label="位置" />
        <el-table-column prop="type" label="类型" />
        <el-table-column prop="required" label="必填" />
        <el-table-column prop="desc" label="说明" />
      </el-table>
    </p>
    <strong>DailyScheduleDto</strong>
    <p>
      <el-table size="mini" border :data="DailyScheduleDto">
        <el-table-column prop="name" label="参数名称" />
        <el-table-column prop="loc" label="位置" />
        <el-table-column prop="type" label="类型" />
        <el-table-column prop="required" label="必填" />
        <el-table-column prop="desc" label="说明" />
      </el-table>
    </p>
    <strong>SingleDto</strong>
    <p>
      <el-table size="mini" border :data="SingleDto">
        <el-table-column prop="name" label="参数名称" />
        <el-table-column prop="loc" label="位置" />
        <el-table-column prop="type" label="类型" />
        <el-table-column prop="required" label="必填" />
        <el-table-column prop="desc" label="说明" />
      </el-table>
    </p>
    <strong>TouristDto</strong>
    <p>
      <el-table size="mini" border :data="TouristDto">
        <el-table-column prop="name" label="参数名称" />
        <el-table-column prop="loc" label="位置" />
        <el-table-column prop="type" label="类型" />
        <el-table-column prop="required" label="必填" />
        <el-table-column prop="desc" label="说明" />
      </el-table>
    </p>
    <p class="p-title">
      <strong>请求示例：</strong>
    </p>
    <pre v-highlight><code class="json">
{
    "adultPrice": 120,
    "backDate": "2020-07-25",
    "bookingInfo": "预订须知",
    "businessId": "",
    "callBackUrl": "http://xxx.com/contract/over/",
    "clientPeerAddress": "深圳南山大道",
    "clientPeerMobile": "8008208820",
    "clientPeerName": "南山营业部",
    "contractMoney": 3999,
    "contractNo": "NC-2020-0704-01",
    "dailyScheduleList": [
        {
            "day": 0,
            "destination": "",
            "scheduleDesc": "",
            "starting": "",
            "teamActivitySingleList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ],
            "teamBusSingleList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ],
            "teamFlightSingleList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ],
            "teamFreeTimeSingleList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ],
            "teamHotelSingleList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ],
            "teamMealSelfPaidList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ],
            "teamMealSingleAfternoonTea": {
                "itemDesc": "",
                "itemTimeSpan": 0,
                "itemTimeStart": "13:15",
                "name": "",
                "planPrice": "100元/人",
                "singleInfo": 0
            },
            "teamMealSingleBreakfast": {
                "itemDesc": "",
                "itemTimeSpan": 0,
                "itemTimeStart": "13:15",
                "name": "",
                "planPrice": "100元/人",
                "singleInfo": 0
            },
            "teamMealSingleDinner": {
                "itemDesc": "",
                "itemTimeSpan": 0,
                "itemTimeStart": "13:15",
                "name": "",
                "planPrice": "100元/人",
                "singleInfo": 0
            },
            "teamMealSingleLunch": {
                "itemDesc": "",
                "itemTimeSpan": 0,
                "itemTimeStart": "13:15",
                "name": "",
                "planPrice": "100元/人",
                "singleInfo": 0
            },
            "teamMealSingleNightSnack": {
                "itemDesc": "",
                "itemTimeSpan": 0,
                "itemTimeStart": "13:15",
                "name": "",
                "planPrice": "100元/人",
                "singleInfo": 0
            },
            "teamOtherSingleList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ],
            "teamScenicSpotSingleList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ],
            "teamShipSingleList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ],
            "teamShopSingleList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ],
            "teamTrainSingleList": [
                {
                    "itemDesc": "",
                    "itemTimeSpan": 0,
                    "itemTimeStart": "13:15",
                    "name": "",
                    "planPrice": "100元/人",
                    "singleInfo": 0
                }
            ]
        }
    ],
    "days": 6,
    "feeExclude": "费用不包含",
    "feeInclude": "费用包含",
    "feeIntroduce": "费用说明",
    "limitedNum": 20,
    "localAgentName": "玉龙地接社",
    "needBedChildAge": 10,
    "needBedChildPrice": 120,
    "nights": 5,
    "notNeedBedChildAge": 5,
    "notNeedBedChildPrice": 50,
    "notes": "注意事项",
    "orderDate": "2020-07-04",
    "outlineTravel": "行程简介",
    "payDate": "2020-07-04",
    "payWay": "微信支付",
    "peopleNum": 10,
    "productName": "宁波栎社--越南芽庄 参考航班： VJ5307（北京时间 18：40-越南时间 21：40）注：越南时间比中国时间慢 1 个小时各位贵宾于指定时间在宁波栎社机场集合，搭乘",
    "saleMan": "蔡某某",
    "sealUrl": "http://enterpriseresourceplan.tourtech.cn/uploads/2018/5/23/1/eee1a67261db48febae66451b046eada.png",
    "signatory": "王某某",
    "signatoryCardTypeName": "身份证",
    "signatoryEmail": "1927926569@qq.com",
    "signatoryIdNo": "360721199509202000",
    "signatorySex": "男",
    "signatoryTelephone": "18617159405",
    "teamNo": "TH-20200720-01",
    "touristDtos": [
        {
            "address": "",
            "age": 0,
            "birthday": "",
            "cardNo": "",
            "cardTypeName": "",
            "linkMan": true,
            "mobile": "",
            "price": 0,
            "remark": "",
            "sex": "",
            "touristName": ""
        }
    ],
    "touristNames": [],
    "travelCharacteristic": "行程特色",
    "unsubscribeInfo": "退订须知",
    "useDate": "2020-07-20"
}
</code></pre>
    <p class="p-title">
      <strong>返回参数说明：</strong>
    </p>
    <p>
      <el-table size="mini" border :data="response">
        <el-table-column prop="name" label="参数名称" />
        <el-table-column prop="type" label="类型" />
        <el-table-column prop="desc" label="说明" />
      </el-table>
    </p>
    <p class="p-title">
      <strong>返回示例：</strong>
    </p>
    <pre v-highlight>
      <code class="json">
{
    "code": "",
    "contractId": "",
    "msg": ""
}
      </code>
      </pre>
  </el-card>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      request: [
        // {name:'sign-access-key',loc:'HEAD',type:'String',required:'是',desc:'鉴权key'},
        // {name:'sign-access-auth',loc:'HEAD',type:'String',required:'是',desc:'鉴权串'},
        {
          name: "contractCode",
          loc: "PATH",
          type: "String",
          required: "是",
          desc: "合同模板Code"
        },
        {
          name: "businessId",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "业务唯一标识，调用方业务系统内的唯一标识"
        },
        {
          name: "contractNo",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "合同号码"
        },
        {
          name: "sealUrl",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "公司印章图片URL"
        },
        {
          name: "signatory",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "签约人"
        },
        {
          name: "signatoryCardTypeName",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "签约人证件类型"
        },
        {
          name: "signatoryIdNo",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "签约人证件号码"
        },
        {
          name: "signatoryTelephone",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "签约人手机号"
        },
        {
          name: "signatoryEmail",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "签约人电子邮箱"
        },
        {
          name: "signatorySex",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "签约人性别"
        },
        {
          name: "adultPrice",
          loc: "BODY",
          type: "BigDecimal",
          required: "否",
          desc: "订单成人销售单价"
        },
        {
          name: "backDate",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "回程日期"
        },
        {
          name: "bookingInfo",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "预订须知"
        },
        {
          name: "callBackUrl",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "回调地址get请求"
        },
        {
          name: "clientPeerAddress",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "渠道/门店地址"
        },
        {
          name: "clientPeerMobile",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "渠道/门店联系方式"
        },
        {
          name: "clientPeerName",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "渠道/门店名称"
        },
        {
          name: "contractMoney",
          loc: "BODY",
          type: "BigDecimal",
          required: "否",
          desc: "合同总金额"
        },
        {
          name: "days",
          loc: "BODY",
          type: "Integer",
          required: "否",
          desc: "天数"
        },
        {
          name: "feeExclude",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "费用不包含"
        },
        {
          name: "feeInclude",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "费用包含"
        },
        {
          name: "feeIntroduce",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "费用说明"
        },
        {
          name: "limitedNum",
          loc: "BODY",
          type: "Integer",
          required: "否",
          desc: "最低成团人数"
        },
        {
          name: "localAgentName",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "地接社名称"
        },
        {
          name: "needBedChildAge",
          loc: "BODY",
          type: "Integer",
          required: "否",
          desc: "占床儿童年龄"
        },
        {
          name: "needBedChildPrice",
          loc: "BODY",
          type: "BigDecimal",
          required: "否",
          desc: "订单占床儿童销售单价"
        },
        {
          name: "nights",
          loc: "BODY",
          type: "Integer",
          required: "否",
          desc: "晚数"
        },
        {
          name: "notNeedBedChildAge",
          loc: "BODY",
          type: "Integer",
          required: "否",
          desc: "不占床儿童年龄"
        },
        {
          name: "notNeedBedChildPrice",
          loc: "BODY",
          type: "BigDecimal",
          required: "否",
          desc: "订单不占床儿童销售单价"
        },
        {
          name: "notes",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "注意事项"
        },
        {
          name: "orderDate",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "预定日期"
        },
        {
          name: "outlineTravel",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "行程简介"
        },
        {
          name: "payDate",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "取值订单支付日期"
        },
        {
          name: "payWay",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "订单支付方式"
        },
        {
          name: "peopleNum",
          loc: "BODY",
          type: "Integer",
          required: "否",
          desc: "游客人数"
        },
        {
          name: "productName",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "产品名称/团队名称"
        },
        {
          name: "saleMan",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "订单销售员"
        },
        {
          name: "teamNo",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "团号"
        },
        {
          name: "touristNames",
          loc: "BODY",
          type: "List<String>",
          required: "否",
          desc: "游客姓名"
        },
        {
          name: "travelCharacteristic",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "行程特色"
        },
        {
          name: "unsubscribeInfo",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "退订须知"
        },
        {
          name: "useDate",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "出发日期"
        },
        {
          name: "dailyScheduleList",
          loc: "BODY",
          type: "List<DailyScheduleDto>",
          required: "否",
          desc: "日程"
        },
        {
          name: "touristDtos",
          loc: "BODY",
          type: "List<TouristDto>",
          required: "否",
          desc: "游客名单"
        }
      ],
      DailyScheduleDto: [
        {
          name: "day",
          loc: "BODY",
          type: "Integer",
          required: "是",
          desc: "第几天"
        },
        {
          name: "destination",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "目的地"
        },
        {
          name: "scheduleDesc",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "日程描述"
        },
        {
          name: "starting",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "出发地"
        },
        {
          name: "teamActivitySingleList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "活动单项"
        },
        {
          name: "teamBusSingleList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "线路用车单项"
        },
        {
          name: "teamFlightSingleList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "线路航班单项"
        },
        {
          name: "teamFreeTimeSingleList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "自由活动单项"
        },
        {
          name: "teamHotelSingleList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "线路酒店单项"
        },
        {
          name: "teamMealSelfPaidList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "其他餐食"
        },
        {
          name: "teamMealSingleAfternoonTea",
          loc: "BODY",
          type: "SingleDto",
          required: "否",
          desc: "每日餐食单项：下午茶"
        },
        {
          name: "teamMealSingleBreakfast",
          loc: "BODY",
          type: "SingleDto",
          required: "否",
          desc: "每日餐食单项：早餐"
        },
        {
          name: "teamMealSingleDinner",
          loc: "BODY",
          type: "SingleDto",
          required: "否",
          desc: "每日餐食单项：晚餐"
        },
        {
          name: "teamMealSingleLunch",
          loc: "BODY",
          type: "SingleDto",
          required: "否",
          desc: "每日餐食单项：午餐"
        },
        {
          name: "teamMealSingleNightSnack",
          loc: "BODY",
          type: "SingleDto",
          required: "否",
          desc: "每日餐食单项：夜宵"
        },
        {
          name: "teamOtherSingleList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "线路其他单项"
        },
        {
          name: "teamScenicSpotSingleList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "景区单项"
        },
        {
          name: "teamShipSingleList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "轮船单项"
        },
        {
          name: "teamShopSingleList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "线路购物店单项"
        },
        {
          name: "teamTrainSingleList",
          loc: "BODY",
          type: "List<SingleDto>",
          required: "否",
          desc: "线路火车单项"
        }
      ],
      SingleDto: [
        {
          name: "itemDesc",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "描述"
        },
        {
          name: "itemTimeSpan",
          loc: "BODY",
          type: "Integer",
          required: "否",
          desc: "单项时长"
        },
        {
          name: "itemTimeStart",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "开始时间"
        },
        {
          name: "name",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "名称"
        },
        {
          name: "planPrice",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "参考价格"
        },
        {
          name: "singleInfo",
          loc: "BODY",
          type: "Integer",
          required: "否",
          desc: "单项信息：1=包含、2=自理、3=自费"
        }
      ],
      TouristDto: [
        {
          name: "touristName",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "游客名称"
        },
        {
          name: "cardNo",
          loc: "BODY",
          type: "String",
          required: "是",
          desc: "证件号"
        },
        {
          name: "age",
          loc: "BODY",
          type: "Integer",
          required: "是",
          desc: "年龄"
        },
        {
          name: "address",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "所在地"
        },
        {
          name: "birthday",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "出生日期"
        },
        {
          name: "cardTypeName",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "证件类型"
        },
        {
          name: "isLinkMan",
          loc: "BODY",
          type: "Boolean",
          required: "否",
          desc: "是否是联系人"
        },
        {
          name: "mobile",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "手机号"
        },
        {
          name: "price",
          loc: "BODY",
          type: "BigDecimal",
          required: "否",
          desc: "价格"
        },
        {
          name: "remark",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "备注"
        },
        {
          name: "sex",
          loc: "BODY",
          type: "String",
          required: "否",
          desc: "性别"
        }
      ],
      response: [
        { name: "code", type: "String", desc: "响应码，1000代表操作成功" },
        { name: "contractId", type: "String", desc: "电子合同Id" },
        { name: "msg", type: "String", desc: "响应信息" }
      ]
    };
  }
};
</script>
